<template>
  <div class="digilam-vs-litholam-costs">
    <img src="images/why-digital/manufacturing-benefits/dvsl_costs_case_two.png" alt="">
    <p class="footnote">Calculations were performed in $ per MSF, then converted to € per SQM. The conversion was based
      on an exchange
      rate of €1 = $1.069. Liner costs not included in results.</p>
  </div>
</template>

<style lang="scss" scoped>
@import "@/scss/views/why-digital/manufacturing-time.scss";
.digilam-vs-litholam-costs {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  img {
    height: 60vh;
  }
}
</style>
